import React, {useEffect, useState} from 'react';
import {Grid,} from '@material-ui/core'

import {CategoryCards, DashboardHeader} from '../../../components'
import './style.scss'
import DataTable from '../../../components/dataTable/servicesSelectionDatatable'
import {servicesData, servicesHeadCells, supplierData, vendorsData,} from './constant'
import axios from 'axios';
import {getUserDataFromLocalStorage} from "../../../services/utils";
import {APP_DOMAIN_PREFIX} from "../../../environment";

function MyServices(props) {
  let loginUser = getUserDataFromLocalStorage()
  const [activeCat, setActiveCat] = useState('services')
  let [rows, column] = activeCat === 'supplies' ? [supplierData, servicesHeadCells] :
    activeCat === 'vendor' ? [vendorsData, servicesHeadCells] : activeCat === 'services' ? [servicesData, servicesHeadCells] : [[], []]
  // = activeCat === 'supplies' ? supplierHeadCells : vendorsHeadCells;
  const [loading, setLoading] = useState(true)
  const [service, setService] = useState([])

  useEffect(() => {
    setLoading(true)
    axios.post(`${APP_DOMAIN_PREFIX}/api/servcies/list/ssoId/${loginUser.ssoId}`).then(res => {
      if (res) {
        setService(res.data)
        setLoading(false)
      }
    });
  }, []);

  const addNewHandler = () => {
    props.history.push('/addservice')
  }
  return (
    <Grid container direction={'column'} className='p-20 content-main-container'>
      <DashboardHeader pageTitle={'My services'} addNewItem={'add New Service'} addNewHandler={addNewHandler}/>
      <CategoryCards active={activeCat} setActive={setActiveCat}/>
      <div className="mt-20">
        {
          // (loading) ? <Loader/> :
          //   (usersList && usersList.resp.length > 0) ?
          !loading && <DataTable
            // data={{rows: usersList?.resp, column: headCells,}}
            // data={{rows: data, column: servicesHeadCells,}}
            data={{
              // rows:activeCat==='vendor'? vendorsData:servicesData ,
              // rows: {activeCat === 'supplies'&& supplierData},
              rows: service,
              // column:activeCat==='vendor'? vendorsHeadCells:servicesHeadCells,
              column: column,
            }}
            // vendor={activeCat==='vendor'}
            tableName={activeCat}
            // addNewHandler={activeCat === 'services' ? addNewHandler : () => {
            // }}
            // loading={loading}
            // pagination={{
            //   totalRows: usersList?.pagination?.rowCount,
            //   pageSize: pageSize,
            //   onPageSizeChange: onPageSizeChange,
            //   pageNo: pageNo - 1,
            //   onPageChange: onPageChange
            // }}
          />
          // :
          //     (usersList && !usersList.resp.length > 0 && !loading) ? <NoData text={"no data available"}/>
          //       : <Loader/>
        }
      </div>

    </Grid>
  );
}

export default MyServices;
